import flatpickr from "flatpickr";

const deferred = { resolve: undefined };
export let ready: Promise<boolean> = new Promise((resolve) => deferred.resolve = resolve);

export default function init(): void {
	setupDates();
}

export function setupDate(elementOrSelector: string | HTMLInputElement, config?: Partial<flatpickr.Options.Options>): void {
	const el = $(elementOrSelector as unknown)[0] as HTMLInputElement;
	if (!el || $(el).attr('disabled') || $(el).attr('readonly'))
		return;

	const dateVal = el.value;
	el.value = null;

	const flatPickrControl = flatpickr(el, {
		mode: "single",
		dateFormat: "Y-m-d",
		allowInput: true,
		altInput: true,
		altFormat: "m/d/Y",
		onReady: () => ready = deferred.resolve(true)
	});

	if (dateVal) {
		flatPickrControl.setDate(new Date(dateVal + ' 00:00'), false, "Y-m-d");
	}
}

export function setupDates(): void {
	// find all of the date elements
	const dateInputs = $('input[type="date"]');
	dateInputs.each((i, el) => setupDate(el as HTMLInputElement));
}
